"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remountScripts = exports.getSSITag = exports.getInitialHtml = void 0;
var is_client_side_1 = require("./is_client_side");
function getInitialHtml(id) {
    if (!is_client_side_1.isClientSide()) {
        return null;
    }
    var element = window.document.getElementById(id);
    return element ? element.innerHTML : null;
}
exports.getInitialHtml = getInitialHtml;
function getSSITag(url) {
    return "<!--#include virtual=\"" + url + "\" -->";
}
exports.getSSITag = getSSITag;
function remountScripts(id) {
    if (!is_client_side_1.isClientSide())
        return;
    var element = document.getElementById(id);
    if (element) {
        Array.prototype.slice.call(element.querySelectorAll('script'), 0).forEach(function (script) {
            var newScript = document.createElement('script');
            if (script.src) {
                if (script.getAttribute('type')) {
                    newScript.setAttribute('type', script.getAttribute('type') || '');
                }
                if (script.getAttribute('nomodule') !== null) {
                    newScript.setAttribute('nomodule', script.getAttribute('nomodule') || '');
                }
                newScript.src = script.src;
            }
            else {
                newScript.textContent = script.textContent;
            }
            document.body.appendChild(newScript);
        });
    }
}
exports.remountScripts = remountScripts;
